export default __webpack_public_path__ + "static/media/03_strom-oznaceny-k-tezbe_upr-min.d66f0c90.jpg";